import moment from 'moment/moment';

export const isWeekend = (date) => {
    const day = moment(date, 'DD.MM.YYYY').format('dddd');

    return (
        day === 'Sunday' ||
        day === 'Saturday' ||
        day === i18next.t('isWeekend.return.Sunday') ||
        day === i18next.t('isWeekend.return.Saturday')
    );
};
